import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { ImageWithSkeleton, getOptimisedSrcAttrs } from '@ynap/image';

const bem = new BEMHelper('HowMeasurementsAreMade');

const HowMeasurementsAreMade = ({ picture, measurements, setMeasuringGuide, modifiers }) => {
    const { width, imageUrl, alt, height, title, captionPlain } = picture;
    const imageSrcSet = imageUrl ? getOptimisedSrcAttrs(imageUrl) : null;
    const styleWidth = modifiers?.withoutOverlay ? null : { maxWidth: width };
    return (
        <>
            {measurements?.length > 1 && (
                <NavHMAM currentMeasurement={title} measurements={measurements} setMeasuringGuide={setMeasuringGuide} modifiers={modifiers} />
            )}
            <div className={bem(null, modifiers)}>
                {imageSrcSet && (
                    <div className={bem('imageContainer', modifiers)}>
                        <div style={{ maxWidth: width }} className={bem('image', modifiers)}>
                            <ImageWithSkeleton
                                className={{ imageContainer: bem('imageContainer'), image: bem('imageContainer') }}
                                key={imageSrcSet.src} // Hotfix for image component, not handling lifecycle changes
                                src={imageSrcSet.src}
                                imageSrcset={imageSrcSet.srcSet}
                                imageSrcsetSize={imageSrcSet.sizes}
                                alt={alt}
                                width={width}
                                height={height}
                            />
                        </div>
                    </div>
                )}
                <div style={styleWidth} className={bem('content', modifiers)}>
                    <h3 className={bem('title', modifiers)}>{title}</h3>
                    <p className={bem('caption')}>{captionPlain}</p>
                </div>
            </div>
        </>
    );
};

HowMeasurementsAreMade.propTypes = {
    overlayTitle: PropTypes.string,
    picture: PropTypes.shape({
        imageUrl: PropTypes.string,
        alt: PropTypes.string,
        width: PropTypes.string,
        height: PropTypes.string,
        title: PropTypes.string,
        captionPlain: PropTypes.string,
    }),
    containerClassName: PropTypes.string,
    closeModal: PropTypes.func,
    goBack: PropTypes.func,
    measurements: PropTypes.array,
    setMeasuringGuide: PropTypes.func,
    modifiers: PropTypes.object,
};

export const NavHMAM = ({ measurements, currentMeasurement, setMeasuringGuide, modifiers }) => {
    const [showNext, setShowNext] = useState(false);

    let navRef = useRef();

    const next = () => {
        setShowNext(false);
        navRef.current.scrollLeft = navRef.current.offsetWidth;
    };

    useEffect(() => {
        const { scrollWidth, clientWidth } = navRef.current;
        if (scrollWidth > clientWidth) {
            setShowNext(true);
        }
    }, []);

    return (
        <nav className={bem('navMeasurement', modifiers)}>
            <ul className={bem('navList')} ref={navRef} onScroll={() => setShowNext(false)}>
                {measurements.map(({ measurementLabel, teaser }, index) => {
                    const toggleMeasuringGuide = () => {
                        setMeasuringGuide(measurementLabel);
                    };
                    const selected = measurementLabel === currentMeasurement ? 'selected' : null;
                    return (
                        <li key={`${measurementLabel} ${index}`} className={bem('navItem', selected)}>
                            <a onClick={toggleMeasuringGuide} className={bem('navItemLink')}>
                                {teaser?.teaserTitle}
                            </a>
                        </li>
                    );
                })}
                {showNext && (
                    <li className={bem('navItem')}>
                        <button className={bem('nextButton', modifiers)} type="button" onClick={next} />
                    </li>
                )}
            </ul>
        </nav>
    );
};

NavHMAM.propTypes = {
    measurements: PropTypes.array,
    currentMeasurement: PropTypes.string,
    setMeasuringGuide: PropTypes.func,
    modifiers: PropTypes.object,
};

export default HowMeasurementsAreMade;
